export default class pegGoogleSocialButton extends HTMLElement {
	async connectedCallback() {
		await jPar.util.waitForChildNodes();
		this.#createMarkup();
		this.#getDynamicConf();
	}

	#createMarkup() {
		const template = document.createElement('template');
		const shadowHtml = `<style>
					:host {
						display: flex;
						overflow: hidden;
					}
					
					:host a {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						gap: 4px;
						width: calc(100% - 2px);
						height: 42px;
						color: var(--COLOR_support_black_default);
						background-color: var(--COLOR_support_white_default);
						border-radius: var(--borderRadius_button);
						border: var(--COLOR_support_black_default) 1px solid;
						cursor: pointer;
						text-decoration: none;
					}
					
					::slotted([slot="icon"].wdk-icon) {
						height: 16px !important;
						width: 16px !important;
						margin-right: 4px;
						fill: var(--COLOR_support_black_default) !important;
					}
					
					:host a span {
						font: var(--FONT_highlight_75);
					}
				</style>
				<a aria-label="Google Login" role="button" href="#">
					<slot name="icon"></slot>
					<span class="text"><slot name="buttonText"></slot></span>
				</a>
			`;

		template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);

		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}

	#setHref() {
		const googleDomain = 'https://accounts.google.com/o/oauth2/v2/auth';
		const clientIdParam = '?client_id=' + dynamicConf.google.clientId;
		const stateAttr = this.getAttribute('social-provider-state');
		const state = stateAttr !== null && stateAttr !== '' ? '&state=' + encodeURIComponent(`socialProviderState=${stateAttr}`) : '';
		const redirectUriParam = '&redirect_uri=' + this.getAttribute('redirect-url');
		const staticParams = '&response_type=code&access_type=offline&scope=profile%20email';
		const fullUrl = googleDomain + clientIdParam + state + redirectUriParam + staticParams;

		this.shadowRoot.querySelector('a').setAttribute('href', fullUrl);
	}

	#getDynamicConf() {
		if (typeof dynamicConf === 'object') {
			this.#setHref();
		} else {
			const scriptTag = document.createElement('script');
			scriptTag.setAttribute('src', '/common/dynamicconf');
			this.shadowRoot.appendChild(scriptTag);

			if (!scriptTag.onloadDone) {
				scriptTag.onloadDone = true;
				scriptTag.onload = () => {
					this.#setHref();
				};
			}
		}
	}

	#sanitizeEvilHtml(string) {
		// Das muss nochmal ein richtiger sanatizer werden
		return String(string).replace(
			/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
			'',
		);
	}
}
